import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  React.useEffect(() => {
    document.title = 'About Us - Royal Hooka Lounge | Premium Hookah Experience';
  }, []);

  return (
    <div className="pt-32">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 to-black">
        <div className="container mx-auto px-4">
          <motion.h1 
            className="text-5xl font-serif font-bold text-center text-gold-400 mb-8"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            About Royal Hooka
          </motion.h1>
          <motion.p 
            className="text-xl text-center text-gray-300 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Where tradition meets luxury in the heart of the city
          </motion.p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-3xl font-serif font-bold text-gold-400 mb-6">Our Story</h2>
              <p className="text-gray-300 mb-4">
                Royal Hooka Lounge was founded with a vision to create the most luxurious and authentic hookah experience in the city. Since our establishment, we have been committed to providing our guests with premium quality tobacco, exceptional service, and an ambiance that transports you to a world of relaxation and luxury.
              </p>
              <p className="text-gray-300 mb-4">
                Our team of experienced hookah masters carefully curate each session, ensuring that every puff delivers the perfect blend of flavor and smoothness. We source our tobacco from the finest suppliers around the world, guaranteeing an unparalleled experience.
              </p>
              <p className="text-gray-300">
                Whether you're celebrating a special occasion, conducting business meetings, or simply unwinding after a long day, Royal Hooka Lounge provides the perfect setting for any occasion.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="relative"
            >
              <img 
                src="https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                alt="Luxury hookah setup"
                className="rounded-lg shadow-2xl"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-4">
          <motion.h2 
            className="text-4xl font-serif font-bold text-center text-gold-400 mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Our Values
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: 'Quality',
                description: 'We never compromise on the quality of our products and services. Every hookah is prepared with precision and care.'
              },
              {
                title: 'Luxury',
                description: 'Our lounge is designed to provide a luxurious experience with comfortable seating and elegant ambiance.'
              },
              {
                title: 'Service',
                description: 'Our trained staff is dedicated to providing exceptional service and ensuring your complete satisfaction.'
              }
            ].map((value, index) => (
              <motion.div 
                key={index}
                className="text-center p-6 bg-black/50 rounded-lg border border-gold-500/20"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <h3 className="text-xl font-semibold text-gold-400 mb-3">{value.title}</h3>
                <p className="text-gray-300">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;